import { writable, derived } from "svelte/store";

if (!window.globals) {
    window.globals = [];
    window.globals.searchCollection = [];
}

export const term = writable("");
export const items = writable(window.globals.searchCollection);
export const filteredCollection = derived([term, items], ([$term, $items]) =>
    $items.filter((x) => x.title.toLowerCase().includes($term.toLowerCase()))
);
